import { useState } from 'react'
import { Box, Divider } from '@chakra-ui/react'
import { DailyInterval } from './DailyInterval'
import { customStyles } from '../../common/Select'
import { MultiDayInterval } from './MultiDayInterval/MultiDayInterval'
import { ManualSessionSchedule } from './ManualSessionSchedule'
import ReactSelect from 'react-select'

const scheduleTypeOptions = [
    { value: 'manual', label: 'Manual activation' },
    { value: 'daily', label: 'Daily schedule' },
    { value: 'chained', label: 'Chained schedule' }
]

export const AddInterval = ({ onAddInterval }) => {
    const [intervalType, setIntervalType] = useState(undefined)
    return (
        <Box margin={4}>
            <ReactSelect
                styles={{
                    ...customStyles,
                    container: (base) => ({
                        ...base,
                        width: 'fit-content'
                    })
                }}
                width="210px"
                options={scheduleTypeOptions}
                onChange={setIntervalType}
            />
            <Divider my={3} orientation="horizontal" />
            {intervalType?.value === 'manual' && <ManualSessionSchedule onSave={onAddInterval} />}
            {intervalType?.value === 'daily' && <DailyInterval onSave={onAddInterval} />}
            {intervalType?.value === 'chained' && <MultiDayInterval onSave={onAddInterval} />}
        </Box>
    )
}
